import { render, staticRenderFns } from "./JobStatusChangeRequestsTable.vue?vue&type=template&id=e9e90d34&"
import script from "./JobStatusChangeRequestsTable.vue?vue&type=script&lang=js&"
export * from "./JobStatusChangeRequestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports